import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CurrentUserService } from '®shared/current-user';

@Injectable()
export class ResourceEditGuard implements CanActivate {
  constructor(private currentUserService: CurrentUserService) {}

  canActivate(): Observable<boolean> {
    return this.currentUserService
      .getCurrentUser()
      .pipe(
        map(userAndPermissions =>
          userAndPermissions.permissions.hasSuperuserRole(),
        ),
      );
  }
}
